$(function () {
  var selected_company_url = null

  var last_opened_company = localStorage.getItem('last_company_id')

  if (!last_opened_company) {
    last_opened_company = $('.company:first').addClass('active').attr('data-id')
  }

  $('.companies a[data-id=' + last_opened_company + ']').addClass('active')

  selected_company_url = $('.companies a[data-id=' + last_opened_company + ']').attr('href')

  $(document).on('keyup', function (e) {
    if (e.which === 13) {
      $('.next').trigger('click')
    }
  })

  $('.company').on('click', function (e) {
    e.preventDefault()
    $('.company').removeClass('active')
    $(this).addClass('active')
    selected_company_url = $(this).attr('href')
    localStorage.setItem('last_company_id', $(this).attr('data-id'))
  })

  $('.btn-company.next').on('click', function () {
    window.location.href = selected_company_url
  })
})
